import { ReportsMessages } from '../types';

export const reportsHI: ReportsMessages = {
    'app.reports.insuficient_data': 'रिपोर्ट उत्पन्न करने के लिए पर्याप्त डेटा नहीं है।',
    'app.reports.decile': 'दसवां हिस्सा',
    'app.reports.group_report.title': 'समूह रिपोर्ट',
    'app.reports.longitudinal.title': 'लॉन्गिट्यूडिनल रिपोर्ट',
    'app.reports.comparative_by_group.title': 'समूह के बीच रिपोर्ट',
    'app.reports.comparative_by_individual.title': 'समूह के भीतर रिपोर्ट',
    'app.report.menu.introduction': 'रिपोर्ट की जानकारी',
    'app.report.menu.basic_descriptive_statistics': 'बैकग्राउंड डोमेन',
    'app.report.menu.aggregate_profile': 'संगठित प्रोफ़ाइल',
    'app.report.menu.decile_profile': 'डेसाइल प्रोफ़ाइल',
    'app.report.menu.aggregate_by_demographics': 'जनसांख्यिकी द्वारा संगठित',
    'app.report.menu.background_domain_contrast': 'बैकग्राउंड डोमेन का अंतर',
    'app.report.menu.profile_background_contrast': 'पृष्ठभूमि का अंतर',
    'app.report.menu.profile_contrast': 'प्रोफाइल का अंतर',
    'app.report.menu.experiential_reflection_items': 'अनुभवात्मक विचार आइटम',
    'app.report.menu.country_of_origin': 'उत्पत्ति देश',
    'app.report.menu.gender': 'लिंग',
    'app.report.menu.education': 'शिक्षा',
    'app.report.menu.ethnicity': 'जातीयता',
    'app.report.menu.income': 'आय',
    'app.report.menu.interest': 'रुचि',
    'app.report.menu.politics': 'राजनीति',
    'app.report.menu.religion': 'धर्म',
    'app.report.menu.satisfaction': 'संतोष',
    'app.report.menu.question_1': 'प्रश्न 1',
    'app.report.menu.question_2': 'प्रश्न 2',
    'app.report.menu.question_3': 'प्रश्न 3',
    'app.report.menu.narrative_report': 'वर्णनात्मक रिपोर्ट',
    'app.report.introduction.create_date': 'तारीख बनाई गई:',
    'app.report.introduction.created_by': 'उपयोगकर्ता:',
    'app.report.introduction.program_name': 'कार्यक्रम या अनुभव:',
    'app.report.introduction.group_name': 'BEVI प्रशासन:',
    'app.report.introduction.number_of_participants': 'प्रतिभागियों की संख्या:',
    'app.report.introduction.visualized_by': 'द्वारा देखा गया:',
    'app.report.scales.consistency': 'सुसंगतता',
    'app.report.scales.congruency': 'संगति',
    'app.report.scales.negative_life_events': 'नकारात्मक जीवन घटनाएँ',
    'app.report.scales.needs_closure': 'समापन की आवश्यकता',
    'app.report.scales.needs_fulfillment': 'आवश्यकताओं की पूर्ति',
    'app.report.scales.identity_diffusion': 'पहचान प्रसार',
    'app.report.scales.basic_openness': 'मूलभूत खुलेपन',
    'app.report.scales.self_certitude': 'आत्म निश्चय',
    'app.report.scales.basic_determinism': 'मूलभूत नियतत्व',
    'app.report.scales.socioemotional_convergence': 'सामाजिक-भावनात्मक संगति',
    'app.report.scales.physical_resonance': 'शारीरिक प्रतिध्वनि',
    'app.report.scales.emotional_attunement': 'भावनात्मक समन्वय',
    'app.report.scales.self_awareness': 'स्वयं की जागरूकता',
    'app.report.scales.meaning_quest': 'अर्थ की खोज',
    'app.report.scales.religious_traditionalism': 'धार्मिक पारंपरिकता',
    'app.report.scales.gender_traditionalism': 'लिंग पारंपरिकता',
    'app.report.scales.sociocultural_openness': 'सामाजिक-सांस्कृतिक खुलेपन',
    'app.report.scales.ecological_resonance': 'पर्यावरणीय प्रतिध्वनि',
    'app.report.scales.global_resonance': 'वैश्विक प्रतिध्वनि',
    'app.report.aggregate_profile.high': 'उच्च',
    'app.report.aggregate_profile.low': 'निम्न',
    'app.report.aggregate_profile.average': 'औसत',
    'app.report.background_statistic_item.income_participants': '{0} में से {1} प्रतिभागियों - {2} %',
    'app.report.background_statistic_item.background_information': 'पृष्ठभूमि की जानकारी',
    'app.report.background_statistic_item.lowest': 'न्यूनतम',
    'app.report.background_statistic_item.middle': 'मध्य',
    'app.report.background_statistic_item.highest': 'अधिकतम',
    'app.report.background_statistic_item.age': 'उम्र',
    'app.report.background_statistic_item.average_age': 'औसत उम्र:',
    'app.report.background_statistic_item.answer': 'उत्तर:',
    'app.report.background_statistic_item.not_answer': 'उत्तर नहीं दिया:',
    'app.report.background_statistic_item.range': 'रेंज:',
    'app.report.background_statistic_item.gender': 'लिंग',
    'app.report.background_statistic_item.ethnic_background': 'जातीय बैकग्राउंड',
    'app.report.background_statistic_item.country_of_origin': 'उत्पत्ति देश',
    'app.report.background_statistic_item.raised_in': 'जहाँ पला-बढ़ा',
    'app.report.background_statistic_item.not_raised_in': 'जहाँ नहीं पला-बढ़ा',
    'app.report.background_statistic_item.details': 'विवरण',
    'app.report.background_statistic_item.years_of_education': 'शिक्षा के वर्ष',
    'app.report.background_statistic_item.income': 'आय',
    'app.report.background_statistic_item.average': 'औसत:',
    'app.report.background_statistic_item.marital_status': 'रिश्ते की स्थिति',
    'app.report.background_statistic_item.religion': 'धर्म',
    'app.report.background_statistic_item.interest': 'रुचि',
    'app.report.background_statistic_item.satisfaction': 'संतोष',
    'app.report.background_statistic_item.domain_scores': 'डोमेन स्कोर',
    'app.report.background_statistic_item.validity': 'वैधता',
    'app.report.background_statistic_item.average_missing_items': 'औसत अनुपस्थित आइटम',
    'app.report.background_statistic_item.average_quantitative_completion_time': 'औसत मात्रात्मक पूर्णता समय',
    'app.report.background_statistic_item.full_scale': 'पूर्ण पैमाना',
    'app.report.background_statistic_item.formative_variables': 'I. प्रारंभिक चर',
    'app.report.background_statistic_item.fulfillment_of_core_needs': 'II. मूल आवश्यकताओं की पूर्ति',
    'app.report.background_statistic_item.tolerance_of_disequilibrium': 'III. असंतुलन की सहनशीलता',
    'app.report.background_statistic_item.critical_thinking': 'IV. आलोचनात्मक सोच',
    'app.report.background_statistic_item.self_access': 'V. आत्म पहुँच',
    'app.report.background_statistic_item.other_access': 'VI. अन्य पहुँच',
    'app.report.background_statistic_item.global_access': 'VII. वैश्विक पहुँच',
    'app.report.decile_profile.high': 'उच्च',
    'app.report.decile_profile.low': 'निम्न',
    'app.report.decile_profile.average': 'औसत',
    'app.report.background_domain_contrast.title': 'पृष्ठभूमि डोमेन का अंतर',
    'app.report.background_domain_contrast.lowest_full_scale': 'न्यूनतम पूर्ण पैमाना',
    'app.report.background_domain_contrast.middle_full_scale': 'मध्य पूर्ण पैमाना',
    'app.report.background_domain_contrast.highest_full_scale': 'अधिकतम पूर्ण पैमाना',
    'app.report.background_domain_contrast.mean': 'औसत',
    'app.report.background_domain_contrast.range': 'रेंज',
    'app.report.background_domain_contrast.background_information': 'बैकग्राउंड की जानकारी',
    'app.report.profile_contrast.lowest': 'न्यूनतम',
    'app.report.profile_contrast.middle': 'मध्य',
    'app.report.profile_contrast.highest': 'अधिकतम',
    'app.report.profile_contrast.lowest_optimal_profiles': 'न्यूनतम आदर्श प्रोफाइल',
    'app.report.profile_contrast.middle_optimal_profiles': 'मध्य आदर्श प्रोफाइल',
    'app.report.profile_contrast.highest_optimal_profiles': 'सर्वोच्च आदर्श प्रोफाइल',
    'app.report.aggregate_profile.country_of_origin.selected_country': 'चयनित देश',
    'app.report.aggregate_profile.country_of_origin.selected_countries': 'चयनित देश',
    'app.report.aggregate_profile.religious_orientation.selected_ethnic': 'चयनित जातीय',
    'app.report.aggregate_profile.religious_orientation.selected_ethnics': 'चयनित जातीयताएँ',
    'app.report.aggregate_profile.country_of_origin.other': 'अन्य',
    'app.report.aggregate_profile.religious_orientation.other': 'अन्य',
    'app.report.aggregate_profile.parents_country.same': 'समान',
    'app.report.aggregate_profile.parents_country.different': 'विभिन्न',
    'app.report.aggregate_profile.relationship_status.selected_relationship_status': 'चयनित संबंध स्थिति',
    'app.report.aggregate_profile.religion.selected_religion': 'चयनित धर्म',
    'app.report.aggregate_profile.relationship_status.other': 'अन्य',
    'app.report.aggregate_profile.gender.male': 'पुरुष',
    'app.report.aggregate_profile.gender.female': 'महिला',
    'app.report.aggregate_profile.gender.self_identify': 'स्वयं की पहचान',
    'app.report.aggregate_profile.education.lowest_30': 'न्यूनतम 30%',
    'app.report.aggregate_profile.education.highest_30': 'उच्चतम 30%',
    'app.report.aggregate_profile.ethnicity.selected_ethnicity': 'चयनित जातीयता',
    'app.report.aggregate_profile.ethnicity.selected_ethnicities': 'चयनित जातीयताएँ',
    'app.report.aggregate_profile.ethnicity.other': 'अन्य',
    'app.report.aggregate_profile.income.bottom_third': 'नीचला तिहाई',
    'app.report.aggregate_profile.income.middle_third': 'मध्य तिहाई',
    'app.report.aggregate_profile.income.top_third': 'ऊपरी तिहाई',
    'app.report.aggregate_profile.interest.low': 'निम्न',
    'app.report.aggregate_profile.interest.middle': 'मध्य',
    'app.report.aggregate_profile.interest.high': 'उच्च',
    'app.report.aggregate_profile.politics.low': 'अधिक रूढ़िवादी/पारंपरिक',
    'app.report.aggregate_profile.politics.middle': 'मध्यम/न तो यह न ही वह',
    'app.report.aggregate_profile.politics.high': 'अधिक उदार/प्रगतिशील',
    'app.report.aggregate_profile.age.low': 'निम्न',
    'app.report.aggregate_profile.age.middle': 'मध्य',
    'app.report.aggregate_profile.age.high': 'उच्च',
    'app.report.aggregate_profile.religion.low': 'निम्न',
    'app.report.aggregate_profile.religion.middle': 'मध्य',
    'app.report.aggregate_profile.religion.high': 'उच्च',
    'app.report.aggregate_profile.satisfaction.low': 'निम्न',
    'app.report.aggregate_profile.satisfaction.middle': 'मध्य',
    'app.report.aggregate_profile.satisfaction.high': 'उच्च',
    'app.report.aggregate_profile.mother_father_education.low': 'निम्न',
    'app.report.aggregate_profile.mother_father_education.middle': 'मध्य',
    'app.report.aggregate_profile.mother_father_education.high': 'उच्च',
    'app.report.aggregate_profile.time_spent_other_countries.low': 'निम्न',
    'app.report.aggregate_profile.time_spent_other_countries.middle': 'मध्य',
    'app.report.aggregate_profile.time_spent_other_countries.high': 'उच्च',
    'app.report.aggregate_profile.minority_group.minority': 'अल्पसंख्यक',
    'app.report.aggregate_profile.minority_group.majority': 'बहुसंख्यक',
    'app.report.aggregate_profile.primary_area_of_work.selected_primary_area_of_work': 'चयनित प्राथमिक कार्य क्षेत्र',
    'app.report.aggregate_profile.primary_area_of_work.selected_primary_areas_of_work': 'चयनित प्राथमिक कार्य क्षेत्रों',
    'app.report.aggregate_profile.primary_area_of_work.other': 'अन्य',
    'app.report.aggregate_profile.years_of_language_study.low': 'निम्न',
    'app.report.aggregate_profile.years_of_language_study.middle': 'मध्य',
    'app.report.aggregate_profile.years_of_language_study.high': 'उच्च',
    'app.report.aggregate_profile.academic_rank.low': 'निम्न',
    'app.report.aggregate_profile.academic_rank.middle': 'मध्य',
    'app.report.aggregate_profile.academic_rank.high': 'उच्च',
    'app.report.aggregate_profile.visited_countries.low': 'निम्न',
    'app.report.aggregate_profile.visited_countries.middle': 'मध्य',
    'app.report.aggregate_profile.visited_countries.high': 'उच्च',
    'app.report.aggregate_profile.fluency.low': 'नहीं या न्यूनतम',
    'app.report.aggregate_profile.fluency.middle': 'कुछ हद तक या सीमित रूप से',
    'app.report.aggregate_profile.fluency.high': 'अधिकांशतः धाराप्रवाह या धाराप्रवाह',
    'app.report.aggregate_demographic.core_demographics': 'मुख्य जनसांख्यिकी',
    'app.report.aggregate_demographic.parental_background': 'पारिवारिक पृष्ठभूमि',
    'app.report.aggregate_demographic.political_religious_inclinations': 'राजनीतिक और धार्मिक झुकाव',
    'app.report.aggregate_demographic.education_background': 'शिक्षा की पृष्ठभूमि',
    'app.report.aggregate_demographic.international_cultural_experiences': 'अंतरराष्ट्रीय और सांस्कृतिक अनुभव',
    'app.report.aggregate_demographic.age': 'उम्र',
    'app.report.aggregate_demographic.gender': 'लिंग',
    'app.report.aggregate_demographic.relationship_status': 'संबंध स्थिति',
    'app.report.aggregate_demographic.country_origin': 'उत्पत्ति देश',
    'app.report.aggregate_demographic.parent_country': 'माता-पिता का देश',
    'app.report.aggregate_demographic.mother_education': 'माँ की शिक्षा',
    'app.report.aggregate_demographic.father_education': 'पिता की शिक्षा',
    'app.report.aggregate_demographic.ethnic_background': 'जातीय बैकग्राउंड',
    'app.report.aggregate_demographic.minority_group': 'अल्पसंख्यक समूह',
    'app.report.aggregate_demographic.political_orientation': 'राजनीतिक रुझान',
    'app.report.aggregate_demographic.religious_orientation': 'धार्मिक रुझान',
    'app.report.aggregate_demographic.religious_commitment': 'धार्मिक प्रतिबद्धता',
    'app.report.aggregate_demographic.income_level': 'आय स्तर',
    'app.report.aggregate_demographic.years_education': 'शिक्षा के वर्ष',
    'app.report.aggregate_demographic.primary_area_work': 'प्राथमिक कार्य क्षेत्र',
    'app.report.aggregate_demographic.academic_rank': 'शैक्षिक रैंक',
    'app.report.aggregate_demographic.time_spent_countries': 'अन्य देशों में बिताया गया समय',
    'app.report.aggregate_demographic.visited_countries': 'भ्रमण किए गए देश',
    'app.report.aggregate_demographic.personal_interest': 'व्यक्तिगत रुचि',
    'app.report.aggregate_demographic.study_abroad_satisfaction': 'विदेश में अध्ययन की संतोषजनकता',
    'app.report.aggregate_demographic.fluency': 'धाराप्रवाह',
    'app.report.aggregate_demographic.years_language_study': 'भाषा अध्ययन के वर्ष',
    'app.report.comparative_individual_report_result_title': 'BEVI व्यक्तिगत परिवर्तन रिपोर्ट परिणाम',
    'app.report.comparative_individual_report_result_description': 'एक प्रशासन से दूसरे प्रशासन तक, आप BEVI पर विभिन्न "बैंड" के बीच स्थानांतरित हो रहे हैं (यानी, आप एक प्रशासन से दूसरे प्रशासन तक महत्वपूर्ण परिवर्तन दिखा सकते हैं)। "Being Bevi" आपको उन परिवर्तनों के बारे में अधिक जानकारी दे सकता है जो वास्तव में आपके बीच विभिन्न BEVI व्यवस्थाओं के बीच हो रहे हैं (यानी, Being Bevi वह AI इकाई है जो Beviverse के भीतर रहती है -- निचले दाएं कोने में वृत्त पर क्लिक करें)। यदि नीचे रंगीन पाठ है, तो इसका मतलब आमतौर पर यह होता है कि आपके स्कोर एक BEVI प्रशासन से दूसरे प्रशासन तक महत्वपूर्ण रूप से बदल गए हैं। रंगीन पाठ उन दिशा(ओं) को संदर्भित करता है जिनमें यह परिवर्तन BEVI के विभिन्न प्रशासनों के बीच हुआ है। यदि आप गहराई से देखना चाहते हैं, और BEVI के 17 स्केल पर आपके लिए विशिष्ट परिवर्तनों को देखना चाहते हैं, तो कृपया अपने BEVI प्रशासक से संपर्क करें या BEVI टीम से संपर्क करें।',
    'app.report.comparative_individual_report_result_description_no_change': 'एक प्रशासन से दूसरे प्रशासन तक, आप वही "बैंड" परिवर्तन के भीतर रह रहे हैं। "Being Bevi" आपको उन परिवर्तनों के बारे में अधिक जानकारी दे सकता है जो वास्तव में आपके बीच एक BEVI प्रशासन से दूसरे BEVI प्रशासन तक हो रहे हैं (यानी, Being Bevi वह AI इकाई है जो Beviverse के भीतर रहती है -- निचले दाएं कोने में वृत्त पर क्लिक करें)। यदि आप गहराई से देखना चाहते हैं, और BEVI के 17 स्केल पर आपके लिए विशिष्ट परिवर्तनों को देखना चाहते हैं, तो कृपया अपने BEVI प्रशासक से संपर्क करें या BEVI टीम से संपर्क करें।',
    'app.report.partner_report_result_title': 'BEVI पार्टनर रिपोर्ट परिणाम',
    'app.report.partner_change_report_result_title': 'BEVI पार्टनर परिवर्तन रिपोर्ट परिणाम',
    'app.report.permission.modal_title': 'प्रिय BEVI प्रतिभागी',
    'app.report.permission.modal_description': `
    <h5>आपने पहले ही BEVI लेने की सहमति दी है, लेकिन हम आपके BEVI रिपोर्ट पर काम करने से पहले आपसे निम्नलिखित बातों पर सहमत होने का अनुरोध कर रहे हैं:</h5>  
    <br />
    <p>
    1) कि आप एक या अधिक सत्रों में भाग लेना चाहते हैं जहां आपकी व्यक्तिगत रिपोर्ट पर चर्चा की जाएगी और
    </p>
    <p>
    2) कि आप <b>[#USERS#]</b> को आपकी व्यक्तिगत रिपोर्ट (जैसे, आपकी कथा, स्कोर) की समीक्षा करने और आपके BEVI रिपोर्ट के अर्थ या प्रभावों पर आपके साथ चर्चा करने का अधिकार दे रहे हैं।
    स्वाभाविक रूप से, BEVI के लिए सहमति पत्र में निर्दिष्ट किया गया है कि आपकी व्यक्तिगत परिणाम पूरी तरह से गोपनीय रहेंगी। यदि आपके कोई प्रश्न हैं, या आपको अतिरिक्त जानकारी की आवश्यकता है, तो कृपया उस BEVI प्रशासक से संपर्क करें जो आपके साथ काम कर रहा है।
    </p>
    <p>
    यदि आप ऊपर दिए गए दोनों प्रावधानों को समझते हैं और सहमत हैं, तो कृपया नीचे "मैं सहमत हूँ" बटन पर क्लिक करें।
    </p>
    <center>BEVI में आपकी रुचि के लिए धन्यवाद!</center>
    `,
    'app.report.permission.pending': 'लंबित',
    'app.report.permission.approved': 'मंजूर',
    'app.report.permission.rejected': 'अस्वीकृत',
    'app.report.permission.approve': 'मैं सहमत हूँ',
    'app.report.permission.reject': 'मैं सहमत नहीं हूँ',
    "app.reports.selectAll": "सभी का चयन करें",
    "app.reports.deselectAll": "सभी का चयन हटाएं"
}
